import axios from 'axios'
import * as mUtils from '@/utils/mUtils.js'
import router from '@/router/index.js'
// import * as mUtils from "utils/mUtils";
// import { countryDate } from "utils/date";
// import { axios } from "utils/";
import {
    Message,MessageBox
  } from 'element-ui'
// create an axios instance

const service = axios.create({
    baseURL: process.env.API_ROOT+'v1', // api 的 base_url
    timeout: 60000 // request timeout
   
  })

  // 拦截器
// request interceptor
service.interceptors.request.use(
    config => {
      
      // Do something before request is sent
       // config.headers.token = mUtils._getCookie("token")
     
        config.headers = {
        //'Authorization':'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjdXJyZW50VGltZU1pbGxpcyI6IjE2MDI1ODU1NzU3NjQiLCJpZCI6IjMiLCJ0eXBlIjoiMSIsImV4cCI6MTYwMjY3MTk3NX0.Qk83pVP3wSpJOmuTs65xDiPz6Y7lKCbWKNcwsBDmS_5',
            'Authorization': mUtils.getStore("token"),
            'Content-Type': 'application/json; charset=UTF-8',
            'Access-Control-Allow-Origin':'*',
            'Access-Control-Allow-Method':'POST,GET',
           'dataType':'jsonp'
            // 'responseType': 'arraybuffer'
           }
      return config
    },
    error => {
      console.log('error=====>', error) // for debug
      Promise.reject(error)
    }
  )
  
  service.interceptors.response.use(
  
    // response => response,
    /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     */
    response => {
      let that=this
      const res = response.data

      if(response.headers.authorization){
          if( mUtils.getStore('zm')){
          if( mUtils.getStore('token')){
            mUtils.removeStore('token')

            mUtils.setStore('token',response.headers.authorization)
          }else{
            mUtils.setStore('token',response.headers.authorization)
          }
        }
        else{
          if( mUtils.getStore('token')){
            mUtils.removeStore('token')

            mUtils.setStore('token',response.headers.authorization)
          }else{
            mUtils.setStore('token',response.headers.authorization)
          }
          // mUtils.setStore('token',response.headers.authorization)
        }
      }
      return response;
    },
    error => {
      return Promise.reject(error)
    }
  )
  
  export default service


// WEBPACK FOOTER //
// ./src/utils/request.js